import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class MvaUploadService {
  constructor(protected http: HttpClient) {
  }
  
  saveMvaUploadInfo(mvaUploadItem:MvaUploadItem):Observable<any> {
    return this.http.post<MvaUploadItem>(environment.apiBaseUrl + 'mvaupload/save', mvaUploadItem);
  }
}

export class Attachment
  {
    fileName: string;
    fileType: number;
    content: string;
  } 

  export class MvaUploadItem {
    Countries: string;
    Products: string;
    companyFileAttachment: Attachment;
    productVolFileAttachment: Attachment;
    type:string;
  }

